module.exports = __webpack_public_path__ + "img/rain-resilience.aa17718c.svg";